import React from 'react';
import PropTypes from 'prop-types';
import usePermissions from '@afosto/utils-react/permissions/usePermissions';
import { DataGridPreview } from '@afosto/app-components-react/DataGrid';
import Property from '@afosto/app-components-react/Property';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { boolean as booleanFormatter } from '@afosto/app-components-react/DataGrid/formatters';
import translations from './translations';
import Box from '@material-ui/core/Box';
import LoadingWrapper from '@afosto/components-react/LoadingWrapper';
import Typography from '@material-ui/core/Typography';
import { FormattedMessage } from 'react-intl';
import SECONDS_IN_A_DAY from '../../utils/constants';

const CouponCategoryPreview = ({ isOpen, isLoading, title, onClose, onEdit, category }) => {
  const intl = useIntl();
  const [hasPermissions] = usePermissions(['odr:coupons:read']);
  const { name, defaults } = category ?? {};

  const previewMenu = [
    ...(category && hasPermissions(['odr:coupons:write'])
      ? [
          {
            key: 'coupon_category_edit',
            translationKey: 'actions.edit',
            label: 'Edit',
            icon: 'pencil',
            shortcut: true,
            onClick: onEdit,
          },
        ]
      : []),
  ];

  return (
    <DataGridPreview open={isOpen} title={title} onClose={onClose} menu={previewMenu}>
      <LoadingWrapper isLoading={isLoading}>
        <Box px={2}>
          <Property label={intl.formatMessage(translations.properties.name.label)} value={name} />
          <Typography variant="button" component="div" style={{ marginTop: 40 }}>
            <FormattedMessage {...translations.properties.defaultSettings.label} />
          </Typography>
          <Property
            label={intl.formatMessage(translations.properties.expiresAfter.label)}
            value={defaults?.expires_after / SECONDS_IN_A_DAY}
          />
          <Property
            label={intl.formatMessage(translations.properties.isUnlimited.label)}
            value={booleanFormatter(defaults?.usage?.is_unlimited)}
          />
          <Property
            label={intl.formatMessage(translations.properties.limit.label)}
            value={defaults?.usage?.limit}
          />
        </Box>
      </LoadingWrapper>
    </DataGridPreview>
  );
};

CouponCategoryPreview.propTypes = {
  category: PropTypes.object,
  isOpen: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClose: PropTypes.func,
  onEdit: PropTypes.func,
  title: PropTypes.string,
};

CouponCategoryPreview.defaultProps = {
  category: {},
  isOpen: false,
  isLoading: false,
  onClose: undefined,
  onEdit: undefined,
  title: null,
};

export default CouponCategoryPreview;
